export default __webpack_public_path__ + "static/media/Tablet.661faf91.jpg";